import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'toast-history-in-map',
  templateUrl: './toast-history-in-map.component.html',
  styleUrls: ['./toast-history-in-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastHistoryInMapComponent {
  @Input() message: string = '';
  @Input() iconClass: string = '';
}
